import { render } from "./RetourTotals.vue?vue&type=template&id=51ffc260"
import script from "./RetourTotals.vue?vue&type=script&setup=true&lang=js"
export * from "./RetourTotals.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Retours/Table/RetourTotals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51ffc260"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51ffc260', __exports__)) {
    api.reload('51ffc260', __exports__)
  }
  
  module.hot.accept("./RetourTotals.vue?vue&type=template&id=51ffc260", () => {
    api.rerender('51ffc260', render)
  })

}


export default __exports__